<template>
    <tbody>
    <tr v-for="row of all_transactions">
        <td>{{ row.id}}</td>
        <td>{{ row.transaction_date}}</td>
        <td><span :style="'color:'+transactionColors[row.type - 1]">{{ transactionTypes[row.type - 1] }}</span></td>
        <td>¥{{ row.amount | formatNumber }}</td>
    </tr>
    </tbody>

</template>

<script>
    import apiBankingTransactions from './../../api/apiBankingTransactions'
    export default {
        components: {},
        data() {
            return {
                transactionTypes: ['Money In', 'Money Out', 'Payment'],
                transactionColors: ['green', 'red', 'blue'],
                rows: [
                    ['1', '2020-06-06', 'Gabriel', 'REF#123', '<span class="has-text-danger">MONEY OUT</span>', '$1450'],
                    ['1', '2020-05-01', 'Juan', 'REF#123', '<span class="has-text-success">MONEY IN</span>', '$1270'],
                    ['1', '2020-04-04', 'Jorge', 'REF#123', '<span class="has-text-primary">PAYMENT</span>', '$370'],
                ]
            }
        },
        computed: {
            all_transactions(){
                return this.$store.getters.getAllTransactions
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            currentRouteName(){
                return this.$route.name;
            }
        },
        methods: {
            transactionDeleteModal(transactionId, type){
                this.$store.commit('setTransactionDeleteModalStatus', true)
                this.$store.commit('setTransactionDeleteId', transactionId)
                this.$store.commit('setBTransactionType', type)
            }
        },
        created() {
            //this.$store.commit('setFilterTransactions', {client: '', search: '', dateFrom: '', dateTo: ''})
            this.$store.commit('setTransactionCurrentPage', this.$route.query.page ? this.$route.query.page : 1)
            this.$store.dispatch('getTransactionsAction');



        }
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UserBanking/TransactionUserTableRow.vue